module.exports = __webpack_public_path__ + "img/gb818-85-m8.prt.8795bc08.jpg";